import GoBackBtn from "./GoBackBtn";

export default GoBackBtn;
